if (!customElements.get('trd-home-counters')) {
  customElements.define('trd-home-counters', class extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-count]'));
      this.finish = () => this.items.forEach(el => { el.textContent = el.dataset.count; });
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotionChange = () => { if (this.motion.matches) { cancelAnimationFrame(this.frame); this.observer?.disconnect(); this.finish(); } };
      this.motion.addEventListener('change', this.onMotionChange);
      this.refreshStatistics();
      this.watchReviews();
      if (this.motion.matches || !('IntersectionObserver' in window)) { this.finish(); return; }
      this.items.forEach(el => { el.textContent = '0'; });
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        let start;
        const tick = now => {
          if (!this.isConnected) return;
          if (start === undefined) start = now;
          const progress = Math.min((now - start) / 1400, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          this.items.forEach(el => { el.textContent = Math.round(Number(el.dataset.count) * eased); });
          if (progress < 1) this.frame = requestAnimationFrame(tick);
          else this.finish();
        };
        this.frame = requestAnimationFrame(tick);
      }, { threshold: 0.2 });
      this.observer.observe(this);
    }
    updateValue(source, value) {
      if (!Number.isSafeInteger(value) || value < 0) return;
      this.querySelectorAll('[data-statistic-source]').forEach(stat => {
        if (stat.dataset.statisticSource !== source) return;
        const counter = stat.querySelector('[data-count]');
        if (!counter || Number(counter.dataset.count) === value) return;
        counter.dataset.count = String(value);
        counter.textContent = String(value);
        const accessible = stat.querySelector('[data-stat-accessible]');
        if (accessible) accessible.textContent = String(value);
      });
    }
    async refreshStatistics() {
      if (!this.querySelector('[data-statistic-source="fulfilled_orders"], [data-statistic-source="purchasing_customers"]')) return;
      this.requestController = new AbortController();
      this.requestTimeout = setTimeout(() => this.requestController.abort(), 30000);
      try {
        const response = await fetch('https://trd-customer-profiles.vercel.app/api/business-report?resource=storefront-stats', {credentials: 'omit', signal: this.requestController.signal});
        if (!response.ok) return;
        const data = await response.json();
        if (!this.isConnected) return;
        this.updateValue('fulfilled_orders', data.fulfilled_orders);
        this.updateValue('purchasing_customers', data.purchasing_customers);
      } catch {} finally { clearTimeout(this.requestTimeout); }
    }
    watchReviews() {
      if (!this.querySelector('[data-statistic-source="google_reviews"]')) return;
      const readReviews = () => {
        const badge = document.querySelector('.grp-entangle--root .grp-total-reviews b');
        const match = badge?.textContent.match(/^\s*([\d,]+)\s+Reviews?\s*$/i);
        if (!match) return false;
        const count = Number(match[1].replaceAll(',', ''));
        if (!Number.isSafeInteger(count) || count < 0) return false;
        this.updateValue('google_reviews', count);
        return true;
      };
      if (readReviews()) return;
      this.reviewObserver = new MutationObserver(() => {
        if (readReviews()) { this.reviewObserver.disconnect(); clearTimeout(this.reviewTimeout); }
      });
      this.reviewObserver.observe(document.body, {childList: true, subtree: true, characterData: true});
      this.reviewTimeout = setTimeout(() => this.reviewObserver?.disconnect(), 60000);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.reviewObserver?.disconnect();
      this.requestController?.abort();
      clearTimeout(this.requestTimeout);
      clearTimeout(this.reviewTimeout);
      cancelAnimationFrame(this.frame);
      this.motion?.removeEventListener('change', this.onMotionChange);
    }
  });
}
